<template>
	<div v-loading="loading">
		<el-table ref="tableData" class="radius-10" :row-key="rowKey" :border="border" :stripe="stripe"
			:max-height="maxHeight" :height="tableType === 'normal' ? height : dialogHeight" :size="tableSize"
			:data="data" :load="loadNode" :lazy="lazy" :tree-props="treeProps" @selection-change="handleSelectionChange"
			@current-change="handleTableCurrentChange" @row-click="handleTableRowClick" @sort-change="handleSortChange"
			@cell-click="handleCellChange" @cell-dblclick="handleDBCellChange" @row-dblclick="handleRowDBClick"
			v-bind="otherConfig" :default-expand-all="expandAll" v-on="$listeners" :highlight-current-row="highlight"
			:header-cell-style="{ background: '#e5e5e5', color: '#000000', height: '3.125rem' }" v-if="!isChange">
			<template v-for="(item, index) in columns">
				<!-- 选择框 -->
				<el-table-column v-if="item.selection" type="selection" width="50" :fixed="item.fixed"
					:reserve-selection="reserveSelection" align="center" header-align="center"
					:key="`selection_${index}`"></el-table-column>
				<!-- 自定义单选框 -->
				<el-table-column v-else-if="item.singleSelection" width="50" :fixed="item.fixed" align="center"
					header-align="center" :key="`singleSelection_${index}`">
					<template slot-scope="scope">
						<el-checkbox v-model="scope.row.isSingleSelected"
							@change="handleSingleSelectionChange(scope.row)"></el-checkbox>
					</template>
				</el-table-column>
				<!-- 序号 -->
				<el-table-column v-else-if="item.index" type="index" width="60" :fixed="item.fixed" label="序号"
					align="center" :index="item.indexMethod || indexMethod" :key="`index_${index}`"></el-table-column>

				<!-- 操作 -->
				<el-table-column v-else-if="item.operation" label="操作" width="260" :fixed="item.fixed" align='center'
					:key="`operation_${index}`">
					<template slot-scope="scope">
						<el-button v-if="item.btnGroup[0]" :size="item.btnGroup[0].size || 'mini'"
							:type="item.btnGroup[0].btnType" :icon="item.btnGroup[0].icon" @click.stop="handleCommand({
								rowData: scope.row,
								command: item.btnGroup[0].type
							})">{{ item.btnGroup[0].name }}
						</el-button>
						<el-button v-if="item.btnGroup[1]" :size="item.btnGroup[1].size || 'mini'"
							:type="item.btnGroup[1].btnType" :icon="item.btnGroup[1].icon" @click.stop="handleCommand({
								rowData: scope.row,
								command: item.btnGroup[1].type
							})">{{ item.btnGroup[1].name }}
						</el-button>
						<el-button v-if="item.btnGroup[2] && item.btnGroup.length <= 3"
							:size="item.btnGroup[2].size || 'mini'" :type="item.btnGroup[2].btnType"
							:icon="item.btnGroup[2].icon" @click.stop="handleCommand({
								rowData: scope.row,
								command: item.btnGroup[2].type
							})">{{ item.btnGroup[2].name }}
						</el-button>
						<el-dropdown style="margin-left: 10px;" v-if="item.btnGroup.length > 3" trigger="click"
							placement="top" @command="handleCommand">
							<el-button type="primary" size="mini">更多<i class="el-icon-arrow-down el-icon--right"></i>
							</el-button>
							<el-dropdown-menu slot="dropdown" style="float: right; padding: 3px 0;margin-left:10px">
								<el-dropdown-item :icon="list.icon" v-for="(list, listIndex) in item.btnGroup"
									:key="list.type" v-show="listIndex !== 0 && listIndex !== 1"
									:command="beforeHandleCommand(scope.row, list.type)">{{
										list.name
									}}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
				<el-table-column v-else-if="item.operationC" label="操作" width="80" fixed="right" align='center'
					:key="`operation1_${index}`">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" icon="icon" @click.stop="handleOperation(scope.row)">{{
							item.label }}
						</el-button>
					</template>
				</el-table-column>
				<!-- 多级表头 -->
				<el-table-column v-else-if="item.multi" align="center" :label="item.label" :key="`multi_${index}`">
					<template v-for="(child, childIndex) in item.children">
						<el-table-column v-if="child.multi" align="center" :label="child.label"
							:key="`childMulti_${index}_${childIndex}`">
							<template>
								<el-table-column v-for="(grandson, grandsonIndex) in child.children"
									:key="`child_${index}_${childIndex}_${grandsonIndex}`" show-overflow-tooltip
									v-bind="grandson">
								</el-table-column>
							</template>
						</el-table-column>
						<slot v-else-if="child.slot" :name="child.slot"></slot>
						<el-table-column v-else show-overflow-tooltip v-bind="child"
							:key="`child_${index}_${childIndex}`">
						</el-table-column>
					</template>
				</el-table-column>
				<!-- 自定义内容 -->
				<slot v-else-if="item.slot" :name="item.slot"></slot>
				<!-- 常规字段 -->
				<el-table-column v-else :show-overflow-tooltip="!item.noTooltip" v-bind="item" :fixed="item.fixed"
					:min-width="item.minWidth" :key="`normal_${index}`"></el-table-column>
			</template>
		</el-table>
	</div>
</template>
<script>
	import {
		MyDebounce
	} from '@/utils/util.js';
	export default {
		name: "STable",
		props: {
			columns: {
				type: Array,
				default: () => [],
			},
			data: {
				type: Array,
				default: () => [],
			},
			tableType: {
				type: String,
				default: 'normal'
			},
			maxHeight: {
				type: [Number, String],
				default: '39rem',
			},
			dialogHeight: {
				type: [Number, String],
				default: '500px',
			},
			height: {
				type: [Number, String],
				default: '500px',
			},
			tableSize: {
				type: String,
				default: "small",
			},
			stripe: {
				type: Boolean,
				default: true,
			},
			border: {
				type: Boolean,
				default: true,
			},
			lazy: {
				type: Boolean,
				default: false,
			},
			expandAll: {
				type: Boolean,
				default: false,
			},
			treeProps: {
				type: Object,
				default: () => {}
			},
			otherConfig: {
				type: Object,
				default: () => {},
			},
			loading: {
				type: Boolean,
				default: false,
			},
			// 支持跨页选择的两个配置项
			rowKey: {
				type: String,
				default: "",
			},
			reserveSelection: {
				type: Boolean,
				default: false,
			},
			highlight: {
				type: Boolean,
				default: false,
			}
		},
		data() {
			return {
				isChange: false,
			};
		},
		activated() {
			this.doLayoutTable();
		},
		mounted() {
			window.addEventListener("resize", this.handleWindowResize);
		},
		beforeDestroy() {
			window.removeEventListener("resize", this.handleWindowResize);
		},
		methods: {
			handleOperation(row) {
				this.$emit('handleOperation', row)
			},
			handleSet(a, b) {
			},
			handleCellChange(row, column, rowIndex, columnIndex) {
				// this.$emit("cell-click", row, column, rowIndex, columnIndex);
			},
			handleDBCellChange(row, column, rowIndex, columnIndex) {
				this.$emit("cell-dbclick", row, column, rowIndex, columnIndex);
			},
			// 切换选择
			handleSelectionChange(val) {
				this.$emit("changeSelection", val);
			},
			// 单选
			handleTableCurrentChange(currentRow) {
				this.$emit("changeCurrent", currentRow);
			},
			// 自定义单选
			handleSingleSelectionChange(currentRow) {
				this.$emit("changeSingleSelection", currentRow);
			},
			// 点击行
			handleTableRowClick(currentRow, currentColumn, currentEvent) {
				this.$emit("rowClick", currentRow, currentColumn, currentEvent);
			},

			// 双击行
			handleRowDBClick(currentRow) {
				this.$emit("rowDBClick", currentRow);
			},

			// 懒加载子表
			loadNode(row, treeNode, resolve) {
				this.$emit("loadChildren", row, treeNode, resolve);
			},

			// 排序
			handleSortChange(val) {
				this.$emit("changeSort", val);
			},
			// 序号列自定义方法
			indexMethod(index) {
				return index + 1;
			},
			// 页面缩放重新计算 table高度
			handleWindowResize() {
				this.$emit("windowResize");
				this.resizeTable()
			},
			// 选项操作按钮
			handleCommand(command) {
				this.$emit("handle-command", command);
			},

			// 对table重新布局
			doLayoutTable() {
				if (this.$refs.tableData && this.$refs.tableData.doLayout) {
					this.$refs.tableData.doLayout();
					this.resizeTable()
				}
			},

			beforeHandleCommand(item, command) {
				return {
					'rowData': item,
					'command': command
				}
			},
			// 判断是否超过可视区域 及有无滚动条
			resizeTable: MyDebounce(function() {
				if (Number(this.$refs.tableData.bodyWidth.split('px')[0]) > this.$refs.tableData.$el.clientWidth) {
					this.$refs.tableData.$el.classList.add('fixed-table')
				} else {
					this.$refs.tableData.$el.classList.remove('fixed-table')
				}
			}, 100),

		},
		watch: {
			columns: {
				handler(newVal) {
					if (newVal && newVal.length) {
						this.isChange = true
						this.$nextTick(() => {
							this.isChange = false
							setTimeout(() => {
								if (this.$refs.tableData && this.$refs.tableData.doLayout) {
									this.$refs.tableData.doLayout();
									this.resizeTable()
								}
							}, 300);
						});
					}
				},
				deep: true,
			},
			data: {
				handler(newVal) {
					if (newVal && newVal.length) {
						this.$nextTick(() => {
							setTimeout(() => {
								this.$refs.tableData.doLayout();
								this.resizeTable()
							}, 300);
						});
					}
				},
				deep: true,
			},
		},
	};
</script>
<style scoped lang="scss">
	::v-deep .el-table__body tr.current-row>td {
		background: #409EFF !important;
		color: #fff !important;
	}
</style>